import { render, staticRenderFns } from "./BrandList.vue?vue&type=template&id=33d15efe&scoped=true"
import script from "./BrandList.vue?vue&type=script&lang=js"
export * from "./BrandList.vue?vue&type=script&lang=js"
import style0 from "./BrandList.vue?vue&type=style&index=0&id=33d15efe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d15efe",
  null
  
)

export default component.exports